// TelcoTrack — /cenik: sazby zaměstnanců vlastní firmy (správce firmy nebo superadmin).

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { hasOrgAdminRole, hasSuperAdminRole } from '@core/shared-bridge';
import { AuthService } from '../services/auth.service';

export const employeeCenikGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  const roles = auth.getSessionRoles();
  if (hasOrgAdminRole(roles) || hasSuperAdminRole(roles)) return true;
  void router.navigate(['/403']);
  return false;
};
